var domains = {
    url: '/api',
    auth: "https://".concat(process.env.REACT_APP_DEBUG ? 'dev-' : '', "auth.ayomi.fr"),
};
export default domains;
